import request from "@/utils/request";

export default function remove(id) {
    return request({
        url: `/storeProductSpecificationValue/agency/remove/`+id,
        method: 'get',
    })
}
